export function salvarBlob(blob: Blob, nome: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = nome;
  a.click();
  URL.revokeObjectURL(url);
}

export function nomeDoArquivo(contentDisposition: string | null, padrao: string): string {
  const m = /filename\*?=(?:UTF-8'')?"?([^";]+)"?/i.exec(contentDisposition ?? '');
  if (!m) return padrao;
  try {
    return decodeURIComponent(m[1].trim());
  } catch {
    return m[1].trim();
  }
}

// Com responseType 'blob' o corpo do erro também chega como Blob.
export async function mensagemDoBlob(erro: any, padrao: string): Promise<string> {
  try {
    const corpo = JSON.parse(await (erro?.error as Blob).text());
    return corpo?.notifications?.[0]?.message ?? corpo?.error ?? corpo?.message ?? corpo?.feedback ?? padrao;
  } catch {
    return padrao;
  }
}

export function ehPdf(contentType: string | null | undefined, nome: string | null | undefined): boolean {
  return /pdf/i.test(contentType ?? '') || /\.pdf$/i.test(nome ?? '');
}

/** PDF na aba nova, como a Agenda; com pop-up bloqueado, baixa. */
export function abrirPdf(blob: Blob, nome: string): void {
  const url = URL.createObjectURL(blob);
  const aba = window.open(url, '_blank');
  if (!aba) {
    salvarBlob(blob, nome);
    URL.revokeObjectURL(url);
    return;
  }
  // A aba precisa da URL viva até carregar.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
